import gql from 'graphql-tag';

const SEND_INVITE_EVENT = gql`
  mutation sendInviteEvent($input: SendInviteEventInput!) {
    sendInviteEvent(input: $input)
  }
`;

const sendInviteEvent =
  client =>
  ({ input }) =>
    client.mutate({
      mutation: SEND_INVITE_EVENT,
      variables: { input }
    });

export default sendInviteEvent;
